import { UnsafeByteStringOperations_instance2qzwn5iz9dqfo as UnsafeByteStringOperations_instance } from '../../../kotlinx-io-kotlinx-io-bytestring/kotlinx/io/bytestring/unsafe/UnsafeByteStringOperations.mjs';
import { readByteArray1fhzfwi2j014k as readByteArray } from './Sources.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readByteString(_this__u8e3s4, byteCount) {
  return UnsafeByteStringOperations_instance.f4i(readByteArray(_this__u8e3s4, byteCount));
}
//region block: exports
export {
  readByteString as readByteString2hnsbql6t4ads,
};
//endregion

//# sourceMappingURL=ByteStrings.mjs.map
